<template>
  <!-- 地域分布地图 -->
  <div style="width: 100%;height: 100%;position: relative;">
    <div :ref="refId" :datas=datas style="width: 100%;height: 100%;"></div>
  </div>
</template>

<script>
import citys from '../city/city.js'
import chain from '../city/chain.json'

// refId              图表id
// datas              数据源
// legendList         图例组件的数据源
// nameColor          文字颜色

export default {
  props: ['refId', 'datas', 'legendList', 'nameColor', 'textcolor', 'Size'],
  data() {
    return {
      pieEcharts: "",
      pieOption: {},
    }
  },
  watch: {
    datas: {
      handler(newValue) {
        this.setPieOption(this.refId, newValue, this.legendList, this.nameColor, this.Size)
      },
      deep: true
    }
  },
  beforeDestroy() {
    if (this.pieEcharts) {
      this.pieEcharts.clear()
    }
  },
  mounted() {
    if (this.datas.length > 0) {
      this.setPieOption(this.refId, this.datas, this.legendList, this.nameColor, this.Size)
    }
  },
  methods: {
    // 处理城市数据绑定对应的坐标点
    handleCity(data) {
      const Citydata = []
      for (let i = 0; i < data.length; i++) {
        let city = data[i].name;
        if (city == undefined) {
          continue;
        }
        city = city.replaceAll("市", "");
        var geoCoord = citys[city];
        if (geoCoord) {
          Citydata.push({
            name: city,
            coord: citys[city],
            value: geoCoord.concat(data[i].value)
          });
        }
      }
      return Citydata
    },
    setPieOption(refId, datas, legendList, nameColor, Size) {
      let dataList = []
      let colorList = [['#44FCF7', '#08E4DE', '#44FCF7', '#08E4DE'], ['#F5B16D', '#F09C42', '#EC870E', '#D0770B']]
      datas.forEach((item, index) => {
        dataList.push({
          name: legendList[index],
          type: 'scatter',
          coordinateSystem: 'geo',
          pointSize: 6, // 设置 热力图 点 的大小
          blurSize: 0, // 设置点的 阴影半径
          itemStyle: {
            normal: {
              color: colorList[index][colorList[index].length - 1]     //设置圆点的颜色
            }
          },
          data: this.handleCity(item),
        })
      });

      // var echarts5 = require('echarts5')
      this.$echarts.registerMap('china', chain);     //注册地图
      this.pieEcharts = this.$echarts.init(this.$refs[refId])
      this.pieOption = {
        tooltip: {
          show: true,
          formatter: function (params) {
            if (params.data['value'] != '' && params.data['value'] != undefined) {
              const value = params.data['value'][2];
              if (value != '' && value != undefined) {
                return params.name + '：' + params.data['value'][2];
              } else {
                return params.name + '：' + params.data['value'];
              }
            }
          },
        },
        legend: {
          left: '6%',
          bottom: '6%',
          orient: 'vertical',
          textStyle: {
            color: nameColor ? nameColor : '#fff',
            fontSize: Size
          },
          data: legendList,
        },
        geo: {
          map: 'china',
          label: {
            emphasis: {
              show: true,
              color: '#fff',
              fontSize: 15
            },
          },
          itemStyle: {
            normal: {
              areaColor: '#135AA3',
              borderColor: '#111'
            },
            emphasis: {
              areaColor: '#2a333d',
            }
          },
          regions: [{
            name: '南海诸岛',//与china.js对应的省份名称
            itemStyle: {
              // areaColor: '#fff',//省份背景色
              borderColor: '#fff'   //边框色
            }
          }]
        },
        visualMap: [{
          min: 0,
          max: 100,
          splitNumber: 5,
          seriesIndex: 0,
          show: false,
          inRange: {
            color: colorList[0]
          },
          textStyle: {
            color: '#fff'
          }
        }, {
          min: 0,
          max: 300,
          show: false,
          splitNumber: 5,
          seriesIndex: 1,
          inRange: {
            color: colorList[1]
          },
          textStyle: {
            color: '#fff'
          }
        }],
        series: dataList
      };
      // 渲染图表
      this.pieEcharts.setOption(this.pieOption);
      window.addEventListener('resize', () => {
        this.pieEcharts.resize();
      })
    },
  }
}
</script>

<style scoped>
.icons {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
</style>
